export default __webpack_public_path__ + "static/media/Chandan-Kumar-Das-Full-Stack-Developer.ed825c3e.pdf";